module.exports = __webpack_public_path__ + "static/media/border-right.22f587ec.svg";